import {
    cloneDeep
} from "../../../../common/js/util";

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
            require: true
        }
    },
    computed: {
        AgentList() {
            return this.$store.state.AgentList;
        }
    },
    data() {
        return {
            visible: false,
            status: [{
                id: '-1',
                text: '全部'
            }, {
                id: '0',
                text: '待审核'
            }, {
                id: '1',
                text: '审核通过'
            }, {
                id: '2',
                text: '审核不通过'
            }],
            type: [{
                id: '-1',
                text: '全部'
            }, {
                id: '0',
                text: '报备申请'
            }, {
                id: '1',
                text: '延期申请'
            }, {
                id: '2',
                text: '转正申请'
            }],
            appTypes: [{
                id: '0',
                text: '合同审核'
            }, {
                id: '1',
                text: '开课申请表审核'
            }],
            checkTypes: [{
                id: 1,
                text: '代理商'
            }, {
                id: 2,
                text: '业务员'
            }],
            PackageTypes: [{
                id: 503,
                text: '在线D65套餐'
            }, {
                id: 504,
                text: '在线D55套餐'
            }, {
                id: 505,
                text: 'HiB在线教育服务包'
            }],
            form: this.getQueryData()
        }
    },
    watch: {
        value(val) {
            this.visible = val;
        },
        visible(val) {
            this.$emit('input', val);
        }
    },
    created() {
        this.visible = this.value;
    },
    methods: {
        search() {
            this.$emit("search", this.form);
        },
        getQueryData() {
            return cloneDeep({
                SchoolName: "", // ---幼儿园名称
                PrincipalName: "", //---园长
                PhoneNo: "", // --电话
                AgentCustomerId: "", // --所属代理商
                createTimeStart: "", // --提交时间
                createTimeEnd: "", //  
                startTime: "", //  --审核时间
                endTime: "", //   --
                StatusType: "", //  类型
                AuditStatus: "", //  状态
                ApplyType: '', //审核类型
                CheckType: '',
                OrderCode: '',
                PackageId: ''
            })
        },
        reset() {
            this.form = this.getQueryData()
            this.$emit("search", this.form);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/checkSchool/search/vm.js